import React, { useState, useEffect, useContext } from 'react';
import { TextField, Button, Box, Autocomplete } from '@mui/material';
import { ErpContext } from "../../context/ErpContext.js";

const CreateItemCategory = () => {
  const { getItemCategoria, postItemCategoria, postItemSubCategoria, itemCategoria ,isNavbarCollapsed,
  } = useContext(ErpContext); // Funciones del contexto
  const [categorias, setCategorias] = useState([]); // Estado para las categorías existentes
  const [nuevaCategoria, setNuevaCategoria] = useState(''); // Estado para la nueva categoría
  const [subCategoria, setSubCategoria] = useState(''); // Estado para la subcategoría
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null); // Estado para la categoría seleccionada

  useEffect(() => {
    getItemCategoria();
  }, []);

  // Manejar el envío de una nueva categoría a la base de datos
  const handleAddCategoria = async () => {
    try {
      await postItemCategoria(nuevaCategoria);  // Enviar la nueva categoría
      alert('Categoría agregada exitosamente');
      setNuevaCategoria(''); // Limpiar el campo
    } catch (error) {
      console.error('Error al agregar la categoría:', error);
    }
  };

  // Manejar el envío de una nueva subcategoría asociada a una categoría seleccionada
  const handleAddSubCategoria = async () => {
    if (!categoriaSeleccionada || !subCategoria) {
      alert('Por favor selecciona una categoría e ingresa una subcategoría');
      return;
    }
    try {
      await postItemSubCategoria(categoriaSeleccionada.id, subCategoria);  // Enviar la subcategoría y el id de la categoría
      alert('Subcategoría agregada exitosamente');
      setSubCategoria(''); // Limpiar el campo
    } catch (error) {
      console.error('Error al agregar la subcategoría:', error);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, padding: 2 }}>
      <h2>Agregar Categoría</h2>
      <TextField
        label="Nueva Categoría"
        value={nuevaCategoria}
        onChange={(e) => setNuevaCategoria(e.target.value)}
      />
      <Button variant="contained" color="primary" onClick={handleAddCategoria}>
        Agregar Categoría
      </Button>

      <h2>Asociar Subcategoría</h2>
      <Autocomplete
        options={itemCategoria}
        getOptionLabel={(option) => option.descripcion}
        value={categoriaSeleccionada}
        onChange={(event, newValue) => setCategoriaSeleccionada(newValue)}
        renderInput={(params) => <TextField {...params} label="Seleccionar Categoría" />}
      />
      <TextField
        label="Nueva Subcategoría"
        value={subCategoria}
        onChange={(e) => setSubCategoria(e.target.value)}
      />
      <Button variant="contained" color="primary" onClick={handleAddSubCategoria}>
        Agregar Subcategoría
      </Button>
    </Box>
  );
};

export default CreateItemCategory;
